module.exports = __webpack_public_path__ + "static/media/cluster-userflow-4.44fee20e.jpg";